import React from 'react';
import {
  FormHookResult,
  DefaultCard,
  CheckBox,
  TextField,
} from 'design-system';
import { Grid } from '@material-ui/core';

type MakeTextFieldProps = {
  id: string;
  label: string;
  key: string;
  loading?: boolean;
  getInputProps: FormHookResult;
};
export function makeTextField({
  id,
  label,
  key,
  loading = false,
  getInputProps,
}: MakeTextFieldProps): JSX.Element {
  return (
    <TextField
      inputId={id}
      data-testid={key}
      inputLabel={label}
      inputName={getInputProps(key).name}
      defaultValue={getInputProps(key).value as string}
      inputError={getInputProps(key).error}
      inputErrorMessage={getInputProps(key).errorText}
      onChange={(val: string): void => {
        getInputProps(key).onChange(val);
      }}
      loading={loading}
    />
  );
}

type MakeCheckboxProps = {
  id: string;
  label: string;
  key: string;
  getInputProps: FormHookResult;
};
export function makeCheckBox({
  id,
  label,
  key,
  getInputProps,
}: MakeCheckboxProps): JSX.Element {
  return (
    <CheckBox
      inputId={id}
      data-testid={key}
      checkTitle={label}
      checkName={key}
      defaultValue={getInputProps(key).value as boolean}
      onChange={(val: boolean): void => {
        getInputProps(key).onChange(val);
      }}
    />
  );
}

export function makeImprovementsSection(
  getInputProps: FormHookResult,
): React.ReactNode {
  return (
    <Grid item xs={12}>
      <DefaultCard
        title="Mejoras del auto (opcional)"
        smallSubtitle="Cuéntanos si tu auto tiene alguna mejora, como accesorios,
              rines nuevos, equipos de sonido, etc."
      >
        <Grid container spacing={1}>
          <Grid item xs={6}>
            {makeCheckBox({
              getInputProps,
              id: 'sales-web-inspection-checkbox-rines',
              label: 'Rines de lujo',
              key: 'rines',
            })}
          </Grid>
          <Grid item xs={6}>
            {makeCheckBox({
              key: 'soundSystem',
              label: 'Equipo de sonido',
              id: 'sales-web-inspection-checkbox-soundsystem',
              getInputProps,
            })}
          </Grid>
          <Grid item xs={12}>
            {makeTextField({
              id: 'sales-web-inspection-input-carimprovements',
              label: 'Otras mejoras',
              getInputProps,
              key: 'carImprovements',
            })}
          </Grid>
        </Grid>
      </DefaultCard>
    </Grid>
  );
}

export function makePreviousDamagesSection(
  getInputProps: FormHookResult,
): React.ReactNode {
  return (
    <Grid item xs={12}>
      <DefaultCard
        title="Daños previos (opcional)"
        smallSubtitle="Cuéntanos si tu auto tiene algún daño como abolladuras en la
              puerta, rayón en el defensa, etc."
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            {makeTextField({
              id: 'sales-web-inspection-input-previousdamage',
              label: 'Daños previos',
              key: 'previousDamage',
              getInputProps,
            })}
          </Grid>
        </Grid>
      </DefaultCard>
    </Grid>
  );
}
